import { cn } from '@/shadcn/lib/utils';

type Props = {
  axis?: 'x' | 'y';
  size?: number | null;
  fillWhite?: boolean;
} & React.SVGProps<SVGSVGElement>;

export const LogoStratumn = ({
  axis = 'x',
  size = null,
  fillWhite = false,
  className,
  ...props
}: Props) => {
  const style = {
    width: axis === 'x' ? size || '100%' : 'auto',
    height: axis === 'y' ? size || '100%' : 'auto'
  };
  return (
    <svg
      viewBox="0 0 134 24"
      fill="none"
      style={style}
      className={cn('block fill-current', className)}
      xmlns="http://www.w3.org/2000/svg"
      data-v-7a283b0c=""
      {...props}
    >
      <path
        d="M2.79244 18.5026C3.67312 19.8269 5.20721 20.6019 6.66647 20.6019C8.10009 20.6019 9.05629 19.9019 9.05629 18.8777C9.05629 17.8783 8.32667 17.1783 6.566 16.5788L5.05685 16.0544C2.18892 15.055 0.654834 13.4058 0.654834 10.9817C0.654834 7.63314 3.22066 5.65912 6.69211 5.65912C8.88099 5.65912 10.7927 6.40867 12.3268 8.10806L9.91203 10.5818C9.05699 9.55691 7.94973 9.05721 6.71705 9.05721C5.48437 9.05721 4.32722 9.58169 4.32722 10.6313C4.32722 11.7058 5.20791 12.1807 7.09468 12.8552L8.5283 13.3797C11.1447 14.3295 12.78 15.9787 12.78 18.652C12.755 21.8257 10.2141 23.9993 6.51611 23.9993C3.67312 23.9993 1.28399 22.7748 0.000732422 20.8256L2.79244 18.5026Z"
        className={cn('text-current', fillWhite && 'text-white')}
        data-v-7a283b0c=""
      />
      <path
        d="M18.8663 9.40686H14.1116V5.95853H27.344V9.40686H22.5394V23.7006H18.8663V9.40686Z"
        className={cn('text-current', fillWhite && 'text-white')}
        data-v-7a283b0c=""
      />
      <path
        d="M30.1108 5.95853H36.9533C40.2993 5.95853 42.4376 8.25742 42.4376 11.2061C42.4376 13.58 41.1294 15.0791 38.7645 15.8286L44.2308 23.6999H40.0997L34.9355 16.2285H33.759V23.6999H30.1115V5.95853H30.1108ZM36.5257 13.1305C37.8838 13.1305 38.8151 12.4057 38.8151 11.2061C38.8151 9.98158 37.8845 9.28228 36.5257 9.28228H33.7583V13.1305H36.5257Z"
        className={cn('text-current', fillWhite && 'text-white')}
        data-v-7a283b0c=""
      />
      <path
        d="M67.0968 9.40686H62.342V5.95853H75.5738V9.40686H70.7692V23.7006H67.0968V9.40686Z"
        className={cn('text-current', fillWhite && 'text-white')}
        data-v-7a283b0c=""
      />
      <path
        d="M85.4101 24C81.1335 24 78.1401 21.1264 78.1401 16.7034V5.95853H81.7876V16.7537C81.7876 19.1028 83.2468 20.5021 85.4101 20.5021C87.5733 20.5021 89.0326 19.1028 89.0326 16.7537V5.95853H92.6801V16.7034C92.6808 21.1264 89.6368 24 85.4101 24Z"
        className={cn('text-current', fillWhite && 'text-white')}
        data-v-7a283b0c=""
      />
      <path
        d="M99.8523 12.1559V23.7006H96.2048V5.95853H99.5252L105.336 13.8546L111.147 5.95853H114.468V23.7006H110.82V12.1559L105.336 19.6273L99.8523 12.1559Z"
        className={cn('text-current', fillWhite && 'text-white')}
        data-v-7a283b0c=""
      />
      <path
        d="M130.856 23.7006L121.699 12.1311V23.7006H118.052V5.95853H121.196L130.353 17.528V5.95853H134V23.7006H130.856Z"
        className={cn('text-current', fillWhite && 'text-white')}
        data-v-7a283b0c=""
      />
      <path
        d="M55.5168 5.95853H52.2719L44.5737 23.7006H63.2399L55.5168 5.95853ZM49.7379 20.4346L53.8815 10.7064L58.0251 20.4346H49.7379Z"
        className={cn('text-current', fillWhite && 'text-white')}
        data-v-7a283b0c=""
      />
      <path
        d="M59.5529 0H48.4644V3.26525H59.5529V0Z"
        className={cn('text-current', fillWhite && 'text-white')}
        data-v-7a283b0c=""
      />
    </svg>
  );
};
